import ProjectPageSection from './ProjectPageSection'
// import EduSection from './EduSection'
// import ExpSection from './ExpSection'
// import SkillsetSection from './SkillsetSection'
// import FoooterTiles from './FooterSection'
import '../assets/css/AboutHeroSection.css'
import Fade from 'react-reveal/Fade';
import i1 from '../assets/img/img1.png'
import i2 from '../assets/img/img2.png'
import i3 from '../assets/img/img3.png'
import i4 from '../assets/img/img4.png'
import i5 from '../assets/img/img5.png'
import i6 from '../assets/img/img6.png'
import i7 from '../assets/img/img7.png'
import i8 from '../assets/img/img8.png'
import i9 from '../assets/img/img9.png'



const arr = [
{ url : i9 , proName : 'Foodies', tech : "React | HTML | CSS | Bootstrap | Astra DB", c1 : '#EA713D', c2 : '#FCE4D9', url2: 'https://github.com/nooras/foodies', url3: 'https://foodies-astra.netlify.app/'},
{ url : i8 , proName : 'Link Profiles', tech : "React | HTML | CSS | Bootstrap | Stepzen Graphql", c1 : '#0094FF', c2 : '#AFDCFC', url2: 'https://github.com/nooras/foodies', url3: 'https://foodies-astra.netlify.app/'},
{ url : i7 , proName : 'Tic-Tac-Toe', tech : "React", c1 : '#7970F1', c2 : '#D4D1F9', url2: 'https://github.com/nooras/React-Tic-Tac-Toe', url3: 'https://react-tic-tac-toe-nooras.netlify.app/'},
{ url : i1 , proName : 'Chichat', tech : "Django | Tailwind CSS | CSS | HTML", c1 : '#EA713D', c2 : '#FCE4D9', url2: 'https://github.com/nooras/ChitChat', url3:'#'},
{ url : i2, proName : 'Online Grocery Delivery System', tech : "Flask | Bootstrap | CSS | HTML", c1 : '#0094FF', c2 : '#AFDCFC', url2: '#', url3:'#'},
{ url : i3, proName : 'Mini Paint', tech : "Python | Tkinter", c1 : '#00488A', c2 : '#BDC5FF', url2: 'https://github.com/nooras/Python-mini-paint-by-tkinter', url3:'#'},
{ url : i4, proName : 'Instagram Clone', tech : "REACT | HTML | CSS | FIREBASE", c1 : '#EA713D', c2 : '#FCE4D9', url2: 'https://github.com/nooras/Instagram-clone-with-React', url3:'#'},
{ url : i5, proName : 'React Shopping Cart', tech : "REACT | JS | HTML | CSS", c1 : '#0094FF', c2 : '#AFDCFC', url2: 'https://github.com/nooras/react-shopping-cart', url3:'https://react-shopping-cart-nooras.herokuapp.com/'},
{ url : i6, proName : 'Income Tax Calculator', tech : "DJANGO | HTML | CSS | HEROKU", c1 : '#00488A', c2 : '#BDC5FF', url2: 'https://github.com/nooras/Income-tax-calculator', url3:'https://incometaxxcalculator.herokuapp.com/'}
];

function Projects() {
  return (
    <div className="AboutPage">
      {arr.map(item => 
      <Fade left>
          <section className="ab1" style={{backgroundColor:item.c2}}>
              <ProjectPageSection url={item.url} tech={item.tech} proname={item.proName} c1={item.c1} url2={item.url2} url3={item.url3}/>
          </section>
      </Fade>
       )}
      {/* <section className="ab2">
        <EduSection />
      </section>
       <section className="ab3 skillset">
        <ExpSection />
      </section>
      
      <section className="ab4 skillset">
        <SkillsetSection />
      </section>
      <section className="ab5">
        <FoooterTiles />
      </section> */}
    </div>
  );
}

export default Projects;
